import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, isRef as _isRef, normalizeStyle as _normalizeStyle, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/logo.png'
import _imports_1 from '@/assets/people.png'
import _imports_2 from '@/assets/Vector1.png'
import _imports_3 from '@/assets/Vector3.png'
import _imports_4 from '../assets/not.wav'


const _hoisted_1 = { class: "logoText" }
const _hoisted_2 = {
  class: "logo ml-4",
  style: {"background-color":"#fff"}
}
const _hoisted_3 = { class: "plantName" }
const _hoisted_4 = { class: "flex item-center" }
const _hoisted_5 = { class: "text-gray-50 ml-2" }
const _hoisted_6 = { class: "text-gray-50" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "w-full flex",
  style: {"height":"100px","background-color":"#080718ff","color":"#fff"}
}
const _hoisted_9 = { class: "header-logo flex flex-col" }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 1,
  style: {"height":"60px"},
  class: "ml-4 mt-2",
  src: _imports_0
}
const _hoisted_13 = { class: "flex items-center" }
const _hoisted_14 = { class: "header-logo-txt ml-6 flex-1" }
const _hoisted_15 = {
  class: "flex-1 ml-6 mt-4",
  style: {"position":"relative"}
}
const _hoisted_16 = ["onClick", "title"]
const _hoisted_17 = { style: {"transform":"skew(0deg)","text-align":"center","line-height":"43px"} }
const _hoisted_18 = ["src"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { style: {"transform":"skew(0deg)","text-align":"center","line-height":"28px"} }
const _hoisted_21 = { style: {"position":"relative","min-width":"230px"} }
const _hoisted_22 = {
  class: "flex items-center",
  style: {"height":"70px"}
}
const _hoisted_23 = {
  class: "text-gray-50 ml-2 flex-1",
  style: {"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis","cursor":"pointer"}
}
const _hoisted_24 = { class: "flex items-center" }
const _hoisted_25 = { class: "parallelogram-1" }
const _hoisted_26 = {
  class: "flex-1",
  style: {"text-align":"center"}
}
const _hoisted_27 = {
  key: 0,
  class: "list-box"
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { key: 0 }
const _hoisted_30 = ["onClick"]

import {
  computed,
  onMounted,
  onUnmounted,
  reactive,
  ref,
  watch,
} from "vue";
import { useRouter } from "vue-router";
// import Header from '@/components/layout/Header.vue';
import enUS from "ant-design-vue/es/locale/en_US";
import zhCN from "ant-design-vue/es/locale/zh_CN";
import zhHK from "ant-design-vue/es/locale/zh_HK";
import { memberStore, setMemberStore } from "@/common/state";
import { ConfigProvider } from "ant-design-vue";
import request from "../common/request";
import { v4 as uuidv4 } from "uuid";
import { config } from "../../project.config";
import BScrollCore from "better-scroll-core";
import { inIframe } from "@/common/tools";
import { getLanguage, getTranslation } from "@/common/translate";

import { langList } from "../common/lang";

import "dayjs/locale/zh-cn";
import moment from 'moment'
import { message } from "ant-design-vue";
import { notification } from 'ant-design-vue';
import WarningPopup from "@/components/warning-manage/warning-popup.vue";
import About from "@/views/AboutView.vue"

const passwordRuleMessageKey =
  "密码至少包含数字，大小写字母和字符的四种组合，长度在12-22之间";

export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

moment.locale('zh-cn')

let member = ref<any>({});
member.value = memberStore.member || {};
const router = useRouter();
let selectedKeys2 = ref<string[]>([]);
let openKeys = ref<string[]>([]);

const { currentRoute } = useRouter();
let ifream = ref(false);
const route = currentRoute.value;
ifream.value = inIframe();

let showAboutModal = ref<boolean>(false)

const colorState = reactive({
  primaryColor: "#00aaa6",
  errorColor: "#ff4d4f",
  warningColor: "#faad14",
  successColor: "#52c41a",
  infoColor: "#686666ff",
});

ConfigProvider.config({
  theme: colorState,
});

const scrollBox1 = ref<any>();
let bsInstance1 = ref<any>();
let bsInstance2 = ref<any>();

let selectMenu: any = ref("");
let selectChilMenu: any = ref(null);
let selectParentCode: any = ref(null);
let childrenMenuList: any = ref([]);
let facName: any = ref("");

watch(
  () => router.currentRoute.value,
  (newValue: any) => {
    selectMenu.value = newValue.path;
    setTimeout(() => {
      getRouterSelect();
    }, 200);
  },
  { immediate: true }
);
const scrollBar = (type: any) => {
  let bor: any = document.getElementById("wrapper");
  if (type == "left") {
    var left: number = bor.scrollLeft + 200;
    if (
      left >
      Number(routerContentWidth.value) - Number(routerWidth.value)
    ) {
      left = Number(routerContentWidth.value) - Number(routerWidth.value);
    }
    bor.scrollTo({
      left: left,
      behavior: "smooth", // 平滑滚动效果
    });
  } else {
    var left2: number = bor.scrollLeft - 200;
    if (left2 < 0) {
      left2 = 0;
    }
    bor.scrollTo({
      left: left2,
      behavior: "smooth", // 平滑滚动效果
    });
  }
};
// 处理路由显示拆分
const getRouterSelect = () => {
  if (!selectMenu.value) return;
  if (!menuList.value) return;

  let menuFirst = menuList.value.find(
    (p: any) => p.route === selectMenu.value
  );
  if (menuFirst) {
    selectParentCode.value = menuFirst.code;
  } else {
    menuList.value.map((d: any) => {
      if (
        d.children &&
        d.children.find((p: any) => p.route === selectMenu.value)
      ) {
        selectParentCode.value = d.code;
        childrenMenuList.value = d.children;
        selectChilMenu.value = d.children.find(
          (p: any) => p.route === selectMenu.value
        ).route;
      }
    });
  }
};

const linkTo = (code: any) => {
  let path = "";
  // selectMenu = path
  let menuInfo = menuList.value.find((p: any) => p.code === code);
  selectParentCode.value = menuInfo.code;
  childrenMenuList.value = menuInfo?.children || [];

  if (menuInfo.children && menuInfo.children.length) {
    path = menuInfo.children[0].route;
    selectChilMenu.value = menuInfo.children[0].route;
  } else {
    path = menuInfo.route;
  }

  if (path.indexOf("http") > -1) {
    router.push({ path: "/nonstandard", query: { url: path } });
  } else {
    router.push(path);
  }
  changeWidth()
};

const linkToChild = (path: any) => {
  selectChilMenu.value = path;
  menuList.value.map((d: any) => {
    if (d.children && d.children.find((p: any) => p.route === path)) {
      childrenMenuList.value = d.children;
    }
  });

  if (path.indexOf("http") > -1) {
    router.push({ path: "/nonstandard", query: { url: path } });
  } else {
    router.push(path);
  }
};

let contentHeight = window.innerHeight;

const state = reactive({
  windowWidth: window.innerWidth,
  windowHeight: window.innerHeight,
});

const resizeHandler = () => {
  state.windowWidth = window.innerWidth;
  state.windowHeight = window.innerHeight;
  changeWidth();
};

let langObj: any = ref({})
let language: any = ref('English')
const t = (key: any) => getLanguage(key, language.value)
const getLang = () => {
  const storedLanguage = localStorage.getItem('language')
  const nextLanguage =
    storedLanguage && langList[storedLanguage]
      ? storedLanguage
      : (language.value || 'English')

  language.value = nextLanguage
  if (!storedLanguage) {
    localStorage.setItem('language', language.value)
  }

  const baseLangObj = langList[language.value] || {}
  langObj.value =
    language.value === 'English'
      ? { ...(langList.menuList || {}), ...baseLangObj }
      : baseLangObj

  moment.locale(language.value === 'English' ? 'en' : 'zh-cn')
}

let modalState = ref({
  visible: false,
  confirmLoading: false,
});

let logoutTimer: any = {};
let logoutTimerClock: any = null;
let isLogout: any = false;
let picUrl: any = ref(null)
let title: any = ref('')

let loadSystemConfig = async () => {
  const config = {
    headers: {
      requestId: uuidv4(),
    },
  };
  let result = await request.get("/api/system/setting", config);

  if (result && result.data) {
    if (result.data.autoLogoutSecond > 0) {
      logoutTimerClock = result.data.autoLogoutSecond * 1000;
    }

    // console.log('member', member)
    //if (!member.value.pwdExpire) {
     // message.warning("首次登录请修改密码！");
      //modalState.value.visible = true;
      //return;
   // }

    //判断是否开启密码过期
    if (result.data.pwdExpire) {
      if (member.value.pwdExpire) {
        if (
          new Date().getTime() - new Date(member.value.pwdExpire).getTime() >=
          0
        ) {
          message.warning("Your password is expiring, please update now");
          modalState.value.visible = true;
        }
      }
    }
  }
};

const getFactoryPT = async () => {
  picUrl.value = null
  title.value = config.projectName

  let result = await request.get('/api/system/setting')

  picUrl.value = result?.data?.logoUrl
  title.value = result?.data?.logoTitle || config.projectName
  document.title = title.value


  if (picUrl.value) {
    let $favicon: any = document.querySelector('link[rel="icon"]');
    if ($favicon !== null) {
      $favicon.href = picUrl.value;
    } else {
      $favicon = document.createElement("link");
      $favicon.rel = "icon";
      $favicon.href = picUrl.value;
      document.head.appendChild($favicon);
    }
  } else {
    let $favicon: any = document.querySelector('link[rel="icon"]');
    if ($favicon !== null) {
      $favicon.href = "/favicon.png";
    } else {
      $favicon = document.createElement("link");
      $favicon.rel = "icon";
      $favicon.href = "/favicon.png";
      document.head.appendChild($favicon);
    }
  }


}

let resetLogoutTimer = () => {
  clearTimeout(logoutTimer);

  if (logoutTimerClock) {
    // 设置30分钟的定时器，超时后执行登出操作
    logoutTimer = setTimeout(() => {
      // 执行登出逻辑，例如调用登出接口或清除用户信息
      if (isLogout) {
        logOut();
      }

    }, logoutTimerClock); // 30分钟，单位为毫秒
  }

};

let formPasswordRef = ref<any>();
let modalFormPwd = ref({
  oldPassword: "",
  password: "",
  checkPassword: "",
});
const rules = computed(() => ({
  password: [
    {
      max: 22,
      min: 6,
      required: true,
      pattern: new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W).{12,}$/),
      message: t(passwordRuleMessageKey),
    },
  ],
  checkPassword: [
    {
      max: 22,
      min: 6,
      required: true,
      pattern: new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W).{12,}$/),
      message: t(passwordRuleMessageKey),
    },
  ],
}));

let changePassword = () => {
  formPasswordRef.value.validate().then(async () => {
    if (modalFormPwd.value.password != modalFormPwd.value.checkPassword) {
      return message.warning(t("输入的新密码不一致!"));
    }

    const config = {
      headers: {
        requestId: uuidv4(),
      },
    };
    let result = await request.put(
      "/api/member/password",
      modalFormPwd.value,
      config
    );
    if (result && result.data) {
      message.success(t("修改成功!"));
      modalState.value.visible = false;
    }
  });
};

const notPlay = () => {
  var audios: any = document.getElementsByClassName("music-audio")[0];
  var vol = audios.volume;
  audios.controls = false;

  const myDiv: any = document.getElementById('music-play')
  const handleClick = () => {
    audios.play();
  }
  myDiv.addEventListener('click', handleClick);
  myDiv.click()
  myDiv.removeEventListener('click', handleClick)
}

const open = (placement: any, content: any) => {
  notification.open({
    message: t("消息"),
    description: content,
    placement,
  });
}

let intervalTimer: any = null
const refresh = () => {
  intervalTimer = setInterval(() => {
    getMessageData()
  }, 1000 * 60 * 5)
}

const getMessageData = async () => {
  let config: any = {
    params: {
      status: 0
    },
    headers: {
      requestId: uuidv4(),
    },
  }

  let result = await request.get("/api/sys-alarm/messages", config)

  // console.log('result', result)
  if (result && result.data && result.data.list && result.data.list.length) {
    // message.info(result.data.list[0].message, 5)
    open('topRight', result.data.list[0].message)
    notPlay()
  }

}


onMounted(() => {
  let nameS = localStorage.getItem('userName')
  if (!nameS) {
    let member: any = localStorage.getItem('memberInfo') || null
    localStorage.setItem('userName', JSON.stringify(JSON.parse(member)?.userName))
  }

  window.addEventListener("resize", resizeHandler);
  // 监听用户操作事件，重置计时器
  window.addEventListener("keydown", resetLogoutTimer);
  window.addEventListener("mousedown", resetLogoutTimer);
  window.addEventListener("touchstart", resetLogoutTimer, { passive: true });
  getLang()
  changeWidth();
  getMember()
  // loadfactorySetting();
  loadSystemConfig();
  getFactoryPT()

  setTimeout(() => {
    refresh()
  }, 1000);

});

onUnmounted(() => {
  window.removeEventListener("resize", resizeHandler);
  window.removeEventListener("keydown", resetLogoutTimer);
  window.removeEventListener("mousedown", resetLogoutTimer);
  window.removeEventListener("touchstart", resetLogoutTimer);
  bsInstance1.value = null;
  bsInstance2.value = null;
  clearInterval(intervalTimer)
});

// 中英文切换
const selectLang = (ev: any) => {
  language.value = ev
  localStorage.setItem('language', ev)

  roterAlive.value = false;
  setTimeout((t: any) => {
    roterAlive.value = true;
    getLang()
    changeWidth();
  }, 10);
}

const getLangColor = (ev: any) => {
  if (language.value == ev) {
    return '#0a7b83ff'
  } else {
    return '#fff'
  }
}

const getMember = async () => {
  let result2 = await request.get("/api/members/info");
  localStorage.setItem('memberInfo', JSON.stringify(result2.data))
}

// 路由宽度
let routerWidth = ref(0);
let routerContentWidth = ref(0);
let routerChildWidth = ref(0);
let routerChildContentWidth = ref("");
const changeWidth = () => {
  let Pwidth = window.innerWidth;
  if (language.value == 'Chinese') {
    routerWidth.value = Pwidth - 460 - 235 - 40;
  } else {
    routerWidth.value = Pwidth - 460 - 235 - 40 - 31;
  }

  routerChildWidth.value = Pwidth - 460 - 446 - 40;

  bsInstance1.value && bsInstance1.value.destroy();
  bsInstance1.value = null
  bsInstance2.value && bsInstance2.value.destroy();
  bsInstance2.value = null

  setTimeout(() => {
    let bor: any = document.getElementById("wrapper");
    bsInstance1.value = new BScrollCore(bor, {
      scrollX: true,
      scrollY: false,
      click: true,
      bounce: true,
      tap: true,
      probeType: 3,
    });
    let bor2: any = document.getElementById("wrapper2");
    bsInstance2.value = new BScrollCore(bor2, {
      scrollX: true,
      scrollY: true,
      click: true,
      bounce: true,
      tap: true,
    });
  }, 500);
};

let roterAlive = ref(true);
let menuList = ref();
// member.menuIds
const getMenu = () => {
  var menuIds = member.value.menus.map((t: any) => t.id);
  request.get("/api/menus").then((res: any) => {
    if (res) {
      res.data = res.data.filter((p: any) => p.status);
      var opend = res.data.filter((t: any) => t.route == route.path);
      if (opend && opend.length) {
        selectedKeys2.value = [opend[0].id];
        openKeys.value = [opend[0].id];
      }
      var mlist = ref<any>([]);
      var oneLevel = res.data.filter((t: any) => t.parentId == 0);
      oneLevel.forEach((t: any) => {
        var list = res.data
          .filter((t2: any) => t2.parentId == t.id)
          .filter((value: any) => menuIds.includes(value.id));
        if (list.length) {
          t.children = list;
          mlist.value.push(t);
        } else if (menuIds.includes(t.id)) {
          mlist.value.push(t);
        }
      });

      function compare(property: any) {
        return function (a: any, b: any) {
          var value1 = a[property];
          var value2 = b[property];
          return value1 - value2;
        };
      }

      mlist.value.sort(compare("sort"));

      mlist.value.map((d: any) => {
        if (d.children && d.children.length) {
          d.children.sort(compare("sort"));
        }
      });

      menuList.value = mlist.value;
      routerContentWidth.value = menuList.value.length * 273;
      getRouterSelect();
    }
  });
};
getMenu();
let factoryIds = ref<any>([]);

/**工厂切换 */
const visible = ref(false);
const onClose = () => {
  visible.value = false;
};

const showChange = () => {
  visible.value = true;
};
const logOut = () => {
  /**操作日志记录 */
  // operateLogs('退出登录');
  /**操作日志记录 */
  localStorage.removeItem("token");
  sessionStorage.removeItem("token");
  localStorage.clear();
  setMemberStore(null);
  router.push("/login");
};
const getFactory = () => {
  const config = {
    params: {},
    headers: {
      requestId: uuidv4(),
    },
  };
  request.get("/api/factories", config).then((res: any) => {
    if (res) {
      if (!res?.data?.length) return;
      let userName = JSON.parse(localStorage.getItem("userName") || '');
      let factory_id = localStorage.getItem("factory_id");
      let info: any = {};
      if (factory_id) {
        info = res.data.find((p: any) => p._id === factory_id);
        if (!info) {
          info = res.data[0];
        }
      } else {
        info = res.data[0];
      }
      selectFactory.value = info._id;
      selectFactoryName.value = info.factoryName;
      localStorage.setItem("factory_id", selectFactory.value);
      roterAlive.value = false;
      setTimeout(() => {
        roterAlive.value = true;
      }, 10);

      if (
        (res.data && res.data.length === 1) ||
        (res.data && res.data.length === 0)
      ) {
        visibleFactory.value = false;
      } else {
        visibleFactory.value = true;
      }

      // 2级工厂
      var list = res.data.map((t: any) => ({
        key: t._id,
        title: t.factoryName,
        value: t._id,
        label: t.factoryName,
        parentId: t.parentId,
        id: t._id,
        type: "factory",
      }));
      let factory = [];
      for (var i = 0; i < list.length; i++) {
        var element = list[i];
        if (!element.parentId) {
          const children = list.filter(
            (t: any) => t.parentId == element.id
          );
          if (children && children.length) {
            element.children = children;
          }
          factory.push(element);
        }
      }
      factoryListAll.value = factory;

      changeFacName("");

      if (localStorage.getItem("currentFactory")) {
        factoryIds.value = JSON.parse(
          localStorage.getItem("currentFactory") || ""
        );
      }
    }
  });
};
getFactory();
let factoryListAll = ref<any>([]);
let factoryList = ref<any>([]);
let visibleFactory = ref(false); //是否显示工厂选择

const changeFacName = (ev: any) => {
  let list = JSON.parse(JSON.stringify(factoryListAll.value));
  factoryList.value = [];
  if (facName.value) {
    list.map((d: any) => {
      if (d.children && d.children.length) {
        let list1 = d.children.filter((p: any) =>
          p.label.includes(facName.value)
        );
        if (list1.length) {
          d.children = list1;
          factoryList.value.push(d);
        } else {
          if (d.label.includes(facName.value)) {
            factoryList.value.push(d);
          }
        }

      } else {
        if (d.label.includes(facName.value)) {
          factoryList.value.push(d);
        }
      }
    });
  } else {
    factoryList.value = list;
  }
};

const factoryChange = (val: any) => {
  factoryIds.value = val;
  if (val) {
    localStorage.setItem("currentFactory", JSON.stringify(val));
  } else {
    localStorage.removeItem("currentFactory");
  }

  roterAlive.value = false;
  setTimeout(() => {
    roterAlive.value = true;
  }, 10);
};

let selectFactory: any = ref("");
let selectFactoryName: any = ref("");
let visibleFac: any = ref(false);
const cancalVis = (ev: any) => {
  if (!ev.relatedTarget) {
    visibleFac.value = false;
  }
};

const selectFac = (ev: any) => {
  selectFactory.value = ev.id;
  selectFactoryName.value = ev.label;
  localStorage.setItem("factory_id", ev.id);
  visibleFac.value = false;

  roterAlive.value = false;
  setTimeout((t: any) => {
    roterAlive.value = true;
  }, 10);
};

// 报警弹窗
let isWarningModalVisible = ref<boolean>(false);


const getLocale = () => {
  if (language.value === "Chinese") return zhCN;
  if (language.value === "Chinese_ft") return zhHK;
  return enUS;
}


return (_ctx: any,_cache: any) => {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_menu_unfold_outlined = _resolveComponent("menu-unfold-outlined")!
  const _component_menu_fold_outlined = _resolveComponent("menu-fold-outlined")!
  const _component_a_cascader = _resolveComponent("a-cascader")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!
  const _component_a_drawer = _resolveComponent("a-drawer")!
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_CaretDownOutlined = _resolveComponent("CaretDownOutlined")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_config_provider = _resolveComponent("a-config-provider")!

  return (_openBlock(), _createBlock(_component_a_config_provider, {
    locale: getLocale()
  }, {
    default: _withCtx(() => [
      (_unref(config).menuVersion === 'V1')
        ? (_openBlock(), _createBlock(_component_a_layout, { key: 0 }, {
            default: _withCtx(() => [
              (!_unref(ifream))
                ? (_openBlock(), _createBlock(_component_a_layout_sider, {
                    key: 0,
                    collapsed: _ctx.collapsed,
                    "onUpdate:collapsed": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.collapsed) = $event)),
                    trigger: null,
                    theme: "dark",
                    collapsible: "",
                    style: _normalizeStyle({
                        height: state.windowHeight + 'px',
                      })
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("div", _hoisted_1, "PHM", 512), [
                        [_vShow, _ctx.collapsed]
                      ]),
                      _withDirectives(_createElementVNode("div", _hoisted_2, _cache[17] || (_cache[17] = [
                        _createElementVNode("img", {
                          style: {"height":"100%"},
                          src: _imports_0
                        }, null, -1)
                      ]), 512), [
                        [_vShow, !_ctx.collapsed]
                      ]),
                      _createVNode(_component_a_menu, {
                        selectedKeys: _unref(selectedKeys2),
                        "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedKeys2) ? (selectedKeys2).value = $event : selectedKeys2 = $event)),
                        openKeys: _unref(openKeys),
                        "onUpdate:openKeys": _cache[1] || (_cache[1] = ($event: any) => (_isRef(openKeys) ? (openKeys).value = $event : openKeys = $event)),
                        mode: "inline",
                        style: _normalizeStyle({
                  height: state.windowHeight - 100 + 'px',
                }),
                        class: "menuOv",
                        theme: "dark"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuList), (item, index) => {
                            return (_openBlock(), _createElementBlock("span", { key: index }, [
                              (item.type == 2)
                                ? (_openBlock(), _createBlock(_component_a_menu_item, {
                                    key: item.id,
                                    onClick: ($event: any) => (linkTo(item.route))
                                  }, {
                                    icon: _withCtx(() => [
                                      (item.icon)
                                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon + '-outlined'), { key: 0 }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    default: _withCtx(() => [
                                      _createTextVNode(" " + _toDisplayString(item.title), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : (_openBlock(), _createBlock(_component_a_sub_menu, {
                                    key: item.id + '_'
                                  }, {
                                    icon: _withCtx(() => [
                                      (item.icon)
                                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon + '-outlined'), { key: 0 }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    title: _withCtx(() => [
                                      _createElementVNode("span", null, _toDisplayString(item.title), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (children) => {
                                        return (_openBlock(), _createBlock(_component_a_menu_item, {
                                          key: children.id,
                                          onClick: ($event: any) => (linkTo(children.route))
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(children.title), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1024))
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["selectedKeys", "openKeys", "style"])
                    ]),
                    _: 1
                  }, 8, ["collapsed", "style"]))
                : _createCommentVNode("", true),
              _createVNode(_component_a_layout, null, {
                default: _withCtx(() => [
                  (!_unref(ifream))
                    ? (_openBlock(), _createBlock(_component_a_layout_header, {
                        key: 0,
                        style: {"padding":"0"},
                        class: "flex",
                        theme: "dark"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, [
                            (_ctx.collapsed)
                              ? (_openBlock(), _createBlock(_component_menu_unfold_outlined, {
                                  key: 0,
                                  class: "trigger",
                                  onClick: _cache[3] || (_cache[3] = () => (_ctx.collapsed = !_ctx.collapsed))
                                }))
                              : (_openBlock(), _createBlock(_component_menu_fold_outlined, {
                                  key: 1,
                                  class: "trigger",
                                  onClick: _cache[4] || (_cache[4] = () => (_ctx.collapsed = !_ctx.collapsed))
                                }))
                          ]),
                          _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(config)?.projectName), 1),
                          _createElementVNode("div", _hoisted_4, [
                            (_unref(visibleFactory))
                              ? (_openBlock(), _createBlock(_component_a_cascader, {
                                  key: 0,
                                  class: "mycasc",
                                  value: _unref(factoryIds),
                                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (_isRef(factoryIds) ? (factoryIds).value = $event : factoryIds = $event)),
                                  options: _unref(factoryList),
                                  placeholder: t('切换工厂(全部)'),
                                  style: {"width":"250px","margin-right":"20px"},
                                  onChange: factoryChange
                                }, null, 8, ["value", "options", "placeholder"]))
                              : _createCommentVNode("", true),
                            _cache[18] || (_cache[18] = _createElementVNode("img", {
                              class: "hidden xl:inline-block",
                              src: _imports_1,
                              width: "20",
                              height: "20"
                            }, null, -1)),
                            _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(member).nickName || _unref(member).userName), 1),
                            _cache[19] || (_cache[19] = _createElementVNode("i", {
                              class: "inline xl:hidden cursor-pointer text-base mx-2",
                              "nz-icon": "",
                              nzType: "logout",
                              nzTheme: "outline"
                            }, null, -1)),
                            _createElementVNode("a", {
                              class: "mx-5 hidden xl:inline-block",
                              onClick: logOut
                            }, [
                              _createElementVNode("span", _hoisted_6, _toDisplayString(t('[安全退出]')), 1)
                            ])
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_layout_content, {
                    id: "ant-layout-content",
                    style: _normalizeStyle({
          margin: '3px 3px',
          padding: '0px 0',
          background: '#fff',
          minHeight: '680px',
          height:
            (_unref(ifream) ? state.windowHeight - 20 : state.windowHeight - 200) +
            'px',
        }),
                    class: "menuOv"
                  }, {
                    default: _withCtx(() => [
                      (_unref(roterAlive))
                        ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["style"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_a_drawer, {
        width: 500,
        title: t('切换工厂'),
        placement: "right",
        visible: visible.value,
        onClose: onClose
      }, null, 8, ["title", "visible"]),
      (_unref(config).menuVersion === 'V2')
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (!_unref(ifream))
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      (_unref(picUrl))
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            style: {"height":"100px"},
                            class: "ml-4 mt-2",
                            src: _unref(picUrl)
                          }, null, 8, _hoisted_11))
                        : (_openBlock(), _createElementBlock("img", _hoisted_12))
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(langObj)[_unref(title)] || _unref(title)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", {
                      style: _normalizeStyle([{"height":"60px","position":"relative"}, { 'width': _unref(routerWidth) + 'px' }]),
                      class: "overflow-hidden",
                      ref: "wrapper",
                      id: "wrapper"
                    }, [
                      _createElementVNode("div", {
                        class: "flex items-center h-full content ml-6 mt-4",
                        style: _normalizeStyle({ 'width': _unref(routerContentWidth) + 'px' })
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuList), (menu, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, [
                            _createElementVNode("div", {
                              onClick: ($event: any) => (linkTo(menu.code)),
                              title: _unref(langObj)[menu.title] || menu.title,
                              style: {"width":"60px","height":"80px","font-size":"18px"},
                              class: _normalizeClass(["ml-2", [_unref(selectParentCode) === menu.code ? 'parallelogram-select' : 'parallelogram-2']])
                            }, [
                              _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("div", {
                                  style: _normalizeStyle({
                      width:'50px',
                      height:'50px',
                      borderRadius:'10px',
                      backgroundColor:_unref(selectParentCode) === menu.code? '#ffbf003b': 'transparent',
                      border:_unref(selectParentCode) === menu.code? '3px solid #ffc000': '1px solid #54626dff',
                      margin: '0 auto',
                      display:'flex',
                      justifyContent:'center',
                      alignItems:'center',
                      boxSizing:'border-box',
                      })
                                }, [
                                  _createElementVNode("img", {
                                    src: require(`@/assets/${_unref(langObj)[menu.title]?.replace(/\s+/g,'')}-removebg.png`),
                                    style: {"width":"25px","height":"auto"}
                                  }, null, 8, _hoisted_18)
                                ], 4)
                              ])
                            ], 10, _hoisted_16)
                          ]))
                        }), 128))
                      ], 4)
                    ], 4),
                    _createElementVNode("div", {
                      style: _normalizeStyle([{"height":"30px"}, { 'width': _unref(routerChildWidth) + 'px' }]),
                      class: "overflow-hidden ml-6",
                      id: "wrapper2"
                    }, [
                      _createElementVNode("div", {
                        class: "flex items-center h-full content",
                        style: _normalizeStyle({ 'width': (_unref(childrenMenuList).length * 191) + 'px' })
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(childrenMenuList), (menu, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, [
                            _createElementVNode("div", {
                              onClick: ($event: any) => (linkToChild(menu.route)),
                              style: {"width":"175px","height":"28px","font-size":"14px"},
                              class: _normalizeClass(["ml-4", [_unref(selectChilMenu) === menu.route ? 'parallelogram-select' : 'parallelogram-2']])
                            }, [
                              _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(langObj)[menu.title] || menu.title), 1)
                            ], 10, _hoisted_19)
                          ]))
                        }), 128))
                      ], 4)
                    ], 4)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _cache[23] || (_cache[23] = _createElementVNode("div", { style: {"width":"20px"} }, null, -1)),
                      _createVNode(_component_UserOutlined, { style: {"font-size":"20px"} }),
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_a_dropdown, null, {
                          overlay: _withCtx(() => [
                            _createVNode(_component_a_menu, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_sub_menu, { key: "sub1" }, {
                                  title: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_24, [
                                      _cache[20] || (_cache[20] = _createElementVNode("img", {
                                        style: {"height":"16px","width":"18px","margin-right":"10px"},
                                        src: _imports_2
                                      }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(_unref(language) == 'English' ? 'English' : ''), 1)
                                    ])
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_menu_item, {
                                      key: "English",
                                      onClick: _cache[7] || (_cache[7] = ($event: any) => (selectLang('English')))
                                    }, {
                                      default: _withCtx(() => _cache[21] || (_cache[21] = [
                                        _createTextVNode("English")
                                      ])),
                                      _: 1,
                                      __: [21]
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_menu_item, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", {
                                      onClick: logOut,
                                      class: "flex items-center"
                                    }, [
                                      _cache[22] || (_cache[22] = _createElementVNode("img", {
                                        style: {"height":"16px","width":"18px","margin-right":"10px"},
                                        src: _imports_3
                                      }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(t("[安全退出]")), 1)
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", {
                              class: "text-gray-50 flex items-center",
                              onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"]))
                            }, [
                              _createTextVNode(_toDisplayString(_unref(member).nickName || _unref(member).userName) + " ", 1),
                              _createVNode(_component_CaretDownOutlined, { style: {"font-size":"16px","padding-left":"5px"} })
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", {
                      tabindex: "-1",
                      onBlur: cancalVis
                    }, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", {
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_isRef(visibleFac) //@ts-ignore
 ? visibleFac.value = !_unref(visibleFac) : visibleFac = !_unref(visibleFac))),
                          class: "flex items-center w-full h-full cursor-pointer",
                          style: {"transform":"skew(0deg)"}
                        }, [
                          _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(getTranslation)(_unref(selectFactoryName))), 1),
                          _createVNode(_component_CaretDownOutlined)
                        ])
                      ]),
                      (_unref(visibleFac))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(factoryList), (item, index) => {
                              return (_openBlock(), _createElementBlock("div", { key: index }, [
                                _createElementVNode("div", {
                                  onClick: ($event: any) => (selectFac(item)),
                                  class: _normalizeClass(["list-info", { 'list-info-select': _unref(selectFactory) === item.id }])
                                }, [
                                  _createElementVNode("span", null, _toDisplayString(_unref(getTranslation)(item.label)), 1)
                                ], 10, _hoisted_28),
                                (item.children && item.children.length)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child, index2) => {
                                        return (_openBlock(), _createElementBlock("div", { key: index2 }, [
                                          _createElementVNode("div", {
                                            onClick: ($event: any) => (selectFac(child)),
                                            class: _normalizeClass(["list-info", { 'list-info-select': _unref(selectFactory) === child.id }]),
                                            style: {"padding":"10px 40px"}
                                          }, [
                                            _createElementVNode("span", null, _toDisplayString(_unref(getTranslation)(child.label)), 1)
                                          ], 10, _hoisted_30)
                                        ]))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ], 32)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_a_modal, {
              width: 550,
              maskClosable: false,
              visible: _unref(modalState).visible,
              "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((_unref(modalState).visible) = $event)),
              title: _unref(getLanguage)('修改密码'),
              "confirm-loading": _unref(modalState).confirmLoading,
              onOk: _unref(changePassword)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form, {
                  model: _unref(modalFormPwd),
                  ref_key: "formPasswordRef",
                  ref: formPasswordRef,
                  name: "basic",
                  rules: rules.value,
                  autocomplete: "off",
                  "label-col": { style: { width: '150px' } }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: _unref(getLanguage)('原密码'),
                      name: "oldPassword",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          type: "password",
                          value: _unref(modalFormPwd).oldPassword,
                          "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_unref(modalFormPwd).oldPassword) = $event)),
                          placeholder: _unref(getLanguage)('请输入原密码')
                        }, null, 8, ["value", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_a_form_item, {
                      label: _unref(getLanguage)('新密码'),
                      name: "password",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          type: "password",
                          value: _unref(modalFormPwd).password,
                          "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_unref(modalFormPwd).password) = $event)),
                          placeholder: _unref(getLanguage)('请输入新密码')
                        }, null, 8, ["value", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_a_form_item, {
                      label: _unref(getLanguage)('再次输入新密码'),
                      name: "checkPassword",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          type: "password",
                          value: _unref(modalFormPwd).checkPassword,
                          "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_unref(modalFormPwd).checkPassword) = $event)),
                          placeholder: _unref(getLanguage)('再次输入新密码')
                        }, null, 8, ["value", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]),
              _: 1
            }, 8, ["visible", "title", "confirm-loading", "onOk"]),
            _createVNode(_component_a_modal, {
              width: 1500,
              maskClosable: false,
              title: t('报警'),
              footer: null,
              visible: _unref(isWarningModalVisible),
              "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => (_isRef(isWarningModalVisible) ? (isWarningModalVisible).value = $event : isWarningModalVisible = $event)),
              forceRender: ""
            }, {
              default: _withCtx(() => [
                _createVNode(WarningPopup, {
                  onConfirm: _cache[13] || (_cache[13] = ($event: any) => (_isRef(isWarningModalVisible) //@ts-ignore
 ? isWarningModalVisible.value = false : isWarningModalVisible = false)),
                  onAlarm: _cache[14] || (_cache[14] = ($event: any) => (_isRef(isWarningModalVisible) //@ts-ignore
 ? isWarningModalVisible.value = true : isWarningModalVisible = true))
                })
              ]),
              _: 1
            }, 8, ["title", "visible"]),
            _createVNode(_component_a_modal, {
              width: 800,
              maskClosable: false,
              title: t('关于'),
              footer: null,
              visible: _unref(showAboutModal),
              "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => (_isRef(showAboutModal) ? (showAboutModal).value = $event : showAboutModal = $event))
            }, {
              default: _withCtx(() => [
                (_unref(showAboutModal))
                  ? (_openBlock(), _createBlock(About, { key: 0 }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["title", "visible"]),
            (_unref(roterAlive))
              ? (_openBlock(), _createBlock(_component_router_view, { key: 1 }))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _cache[24] || (_cache[24] = _createElementVNode("audio", {
        style: {"width":"0","height":"0","position":"absolute"},
        class: "music-audio",
        controls: ""
      }, [
        _createElementVNode("source", {
          src: _imports_4,
          type: "audio/mpeg"
        })
      ], -1)),
      _cache[25] || (_cache[25] = _createElementVNode("button", {
        style: {"width":"0","height":"0","position":"absolute"},
        id: "music-play"
      }, null, -1))
    ]),
    _: 1,
    __: [24,25]
  }, 8, ["locale"]))
}
}

})